<template>
  <div class="mb-2">
    <AppFilter :filters="filterConfig" :filter-submitting="filterSubmitting" @filter="handleFilter">
      <template #extra-actions>
        <b-button
          id="default-filter-new-btn"
          variant="primary"
          type="button"
          class="default-filter-new-btn"
          @click="createPostalCode"
        >
          {{ t('Create Postal Code') }}
        </b-button>
      </template>
    </AppFilter>
  </div>
</template>
<script>
import { BButton } from 'bootstrap-vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';
import { mapGetters } from 'vuex';
import AppFilter from '@/components/AppFilter/AppFilter.vue';

export default {
  components: {
    BButton,
    AppFilter
  },
  mixins: [helper],
  props: {
    values: {
      type: Object,
      required: true
    },
    filterSubmitting: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  data() {
    return {
      filterConfig: [
        {
          id: 'country_code',
          label: 'Country Code',
          type: 'text',
          placeholder: 'Country Code'
        },
        {
          id: 'zipcode',
          label: 'Zip Code',
          type: 'text',
          placeholder: 'Zip Code'
        }
      ]
    };
  },

  methods: {
    handleFilter(filters) {
      this.$emit('filter', filters);
    },
    createPostalCode() {
      this.$router.push('/postal_codes/create');
    }
  },

  computed: {
    ...mapGetters({
      countries: 'app/countries',
      currencies: 'app/currencies'
    })
  },

  async created() {
    await this.$store.dispatch('app/getCountries');
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
